export const URL_API = 'https://enrolements-backend.yelemoney.com/api/';
export const URL = 'https://enrolements-backend.yelemoney.com/';

export const URL_AUTH_API = 'https://enrolements-backend.yelemoney.com/api/auth/';

// https://enrolements-backend.yelemoney.com/
// https://yelemoney-backend.lce-ci.com/